import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=f8d3a98c"
import script from "./ImageCarousel.vue?vue&type=script&lang=ts"
export * from "./ImageCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports